import React, { useState } from 'react';
import dataProvider from '../../lib/dataProvider';
import Ansi from "../../lib/ansi2react";
import { useTranslate } from 'react-admin';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';


const Table = ({data, fields}) => {
  if(!data || data.length < 1)return
  return (
    <table border='1' cellpadding='4' cellspacing='0' style={{borderCollapse: 'collapse', marginTop: '1em'}}>
      <thead>
      <tr style={{backgroundColor:'#eee'}}>
        { fields.map(f_el=><th>{f_el}</th>) }
      </tr>
      </thead>
      <tbody>
      { data.map(el=><tr key={'tr'+el.acct_id}>
        { fields.map(f_el=> {
          if(f_el === 'remote_id')return (
            <td><a href={"mailto:?subject="+el[f_el]} >worldpay</a></td>
          )
          if(f_el === 'email' || f_el === 'res_email')return (
            <td><a href={"mailto:"+el[f_el]} >email</a></td>
          )
          return (
            <td>{el[f_el]}</td>
          )
        }) }
      </tr>)}
      </tbody>
    </table>
  )
}

const Findres = () => {
  const tr = useTranslate();
  const [data, setData] = useState({id: 0, name: '', email: '', remark: '', remoteid: '', arrival: '', resno: '', hostelno: '', username: '', password: ''});
  const [progress, setProgress] = useState(0);
  const [result, setResult] = useState({});
  
  const storeValue = (field, val) => {
    const d = { ...data }
    d[field] = val
    console.log([field, val, d])
    setData(d)
  }

  const handleSearch = (id) => {
    setProgress(id)
    dataProvider.getList('globFindres', { 
      pagination: {page: 1, perPage: 100}, 
      sort: {field: 'id', order: 'ASC'},
      filter: { ...data, ...{id: id}}, 
    })
      .then(res  => {
        if(res.data){
          setResult(res.data)
          storeValue('id', id)
        }
        setProgress(0)
      })
  }
  
  return (         
    <Paper style={{scroll:'auto', paddingBottom: '2em'}} >
      <div style={{ display: 'flex'}}>
        <div style={{ display: 'block', width: '50%'}}>
          <div style={{ fontWeight: 'bold', fontSize: '1.5em', marginTop: '3em', marginLeft: '.25em' }}>{tr('bw.glob.findres.title1')}</div>
          <div style={{ paddingLeft: '1em'}}><span style={{paddingTop: '1em', paddingRight: '.5em', display: 'inline-block', width: '19em'}}>name, firstname: </span><TextField onChange={ev=>storeValue('name', ev.target.value)} variant="outlined" size="small" /></div>
          <div style={{ paddingLeft: '1em'}}><span style={{paddingTop: '1em', paddingRight: '.5em', display: 'inline-block', width: '19em'}}>e-mail: </span><TextField onChange={ev=>storeValue('email', ev.target.value)} variant="outlined" size="small" /></div>
          <div style={{ paddingLeft: '1em'}}><span style={{paddingTop: '1em', paddingRight: '.5em', display: 'inline-block', width: '19em'}}>remark: </span><TextField onChange={ev=>storeValue('remark', ev.target.value)} variant="outlined" size="small" /></div>
          <div style={{ paddingLeft: '1em'}}><span style={{paddingTop: '.3em', paddingRight: '.5em', display: 'inline-block', width: '19em'}}>remote ID (resfeldwert): <br /><font color='grey'>(please enter only the reservation part)</font></span><TextField onChange={ev=>storeValue('remoteid', ev.target.value)} variant="outlined" size="small" inputProps={{ 'data-lpignore': 'true', autoComplete: 'off' }} /></div>
          <div style={{ paddingLeft: '1em'}}><span style={{paddingTop: '.3em', paddingRight: '.5em', display: 'inline-block', width: '19em'}}>arrival: <br /><font color='grey'>(yyyy-mm-dd)</font></span><TextField onChange={ev=>storeValue('arrival', ev.target.value)} variant="outlined" size="small" inputProps={{ 'data-lpignore': 'true', autoComplete: 'off' }} /></div>
          <div style={{ paddingLeft: '1em'}}><span style={{paddingTop: '.3em', paddingRight: '.5em', display: 'inline-block', width: '19em'}}>Res #: <br /><font color='grey'>12-12345 or 12345</font></span><TextField onChange={ev=>storeValue('resno', ev.target.value)} variant="outlined" size="small" inputProps={{ 'data-lpignore': 'true', autoComplete: 'off' }} /></div>
          <div style={{width: '100%', paddingLeft: '20em'}}>
            <Button onClick={()=>handleSearch(1)} variant="contained">search</Button>
            { progress===1 && <CircularProgress size="2em" sx={{ ml: '1em', position: 'absolute' }} /> }
          </div>
        </div>
        <div style={{ display: 'block', width: '50%'}}>
          <div style={{ display: 'block'}}>
            <div style={{ fontWeight: 'bold', fontSize: '1.5em', marginTop: '3em', marginLeft: '.25em' }}>{tr('bw.glob.findres.title2')}</div>
            <div style={{ paddingLeft: '1em'}}><span style={{paddingTop: '1em', paddingRight: '.5em', display: 'inline-block', width: '12em'}}>hostelnummer: </span><TextField onChange={ev=>storeValue('hostelno', ev.target.value)} variant="outlined" size="small" inputProps={{ 'data-lpignore': 'true', autoComplete: 'off' }} /></div>
            <div style={{paddingLeft: '13em'}}>
              <Button onClick={()=>handleSearch(2)} variant="contained">search Hostel</Button>
              { progress===2 && <CircularProgress size="2em" sx={{ ml: '1em', position: 'absolute' }} /> }
            </div>
          </div>
          <div style={{ display: 'block'}}>
            <div style={{ fontWeight: 'bold', fontSize: '1.5em', marginTop: '3em', marginLeft: '.25em' }}>{tr('bw.glob.findres.title3')}</div>
            <div style={{ paddingLeft: '1em'}}><span style={{paddingTop: '1em', paddingRight: '.5em', display: 'inline-block', width: '12em'}}>Benutzername: </span><TextField onChange={ev=>storeValue('username', ev.target.value)} variant="outlined" size="small" /></div>
            <div style={{ paddingLeft: '1em'}}><span style={{paddingTop: '1em', paddingRight: '.5em', display: 'inline-block', width: '12em'}}>Passwort: </span><TextField onChange={ev=>storeValue('password', ev.target.value)} variant="outlined" size="small" /></div>
            <div style={{paddingLeft: '13em'}}>
              <Button onClick={()=>handleSearch(3)} variant="contained">Login Check</Button>
              { progress===3 && <CircularProgress size="2em" sx={{ ml: '1em', position: 'absolute' }} /> }
            </div>
          </div>
        </div>
      </div>
      { result?.id === 1 && <div style={{margin: '1em'}}>
        <div style={{fontWeight: 'bold'}}>Reservationen</div>
        <Ansi>{result?.tres_sql}</Ansi>
        <Table data={result?.tres_res} fields={['login', 'email', 'res_email', 'hid', 'res_nr', 'state', 'arrival', 'comment', 'name (firstname)', 'g_email']} />
        <Ansi>{result?.wp_sql}</Ansi>
        <Table data={result?.wp_res} fields={['id_hostel', 'res_nr', 'amount', 'currency', 'remote_id', 'xml', 'officecode', 'cancel', 'email', 'res_email']} />
      </div> }
      { result?.id === 2 && <div style={{margin: '1em'}}>
        <div style={{fontWeight: 'bold'}}>Nachforschung Hostel</div>
        <Ansi>{result?.h_sql}</Ansi>
        <Table data={result?.h_res} fields={['hostel_id', 'Agent/Schnittstelle', 'agent_id', 'Hostelnumber', 'DormProject', 'login_name', 'hostel', 'cc_text', 'email', 'res_email']} />
      </div> }
      { result?.id === 3 && <div style={{margin: '1em'}}>
        <div style={{fontWeight: 'bold'}}>admin.book.world</div>
        <Ansi>{result?.login_log}</Ansi>
      </div> }
    </Paper>
  )
}
export default Findres;